export default __webpack_public_path__ + "static/media/SIFA_NL_SEQ04.0e238bf5.mp3";